
import React, { useEffect, useRef } from 'react';

interface AdSenseProps {
  slot: string;
  format?: "auto" | "fluid" | "rectangle" | "vertical";
  responsive?: boolean;
  className?: string;
}

// Define the AdSense global object type
declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const AdSense: React.FC<AdSenseProps> = ({
  slot,
  format = "auto",
  responsive = true,
  className = "",
}) => {
  // Use the HTMLInsElement type which we've defined to match HTMLModElement requirements
  const adRef = useRef<HTMLInsElement>(null);
  
  useEffect(() => {
    try {
      // Create a new script element with the specified client ID
      const loadAdScript = () => {
        const existingScript = document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]');
        if (existingScript) return;
        
        const script = document.createElement('script');
        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1993091028153041";
        script.async = true;
        script.crossOrigin = "anonymous";
        document.head.appendChild(script);
      };
      
      loadAdScript();
      
      // Push ads when component mounts
      if (window.adsbygoogle && adRef.current) {
        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
      
    } catch (e) {
      console.error('AdSense error:', e);
    }
    
    return () => {
      // This is just a placeholder for cleanup
    };
  }, []);

  return (
    <div className={`adsense-container ${className}`}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block', textAlign: 'center' }}
        data-ad-client="ca-pub-1993091028153041"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? "true" : "false"}
      />
      <div className="text-xs text-muted-foreground/60 mt-2 text-center">Advertisement</div>
    </div>
  );
};

export default AdSense;
